<template>
  <div>
    <LoadingOverlay v-if="loading" />

    <div v-else-if="!verPerfil" class="lc-root">
      <!-- HEADER -->
      <div class="lc-header">
        <div class="lc-header-left">
          <div class="lc-header-icon">
            <svg
              width="18"
              height="18"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
            >
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
          <div>
            <h1 class="lc-title">Clientes</h1>
            <p class="lc-sub">
              {{ totalServer.toLocaleString("pt-PT") }} clientes
            </p>
          </div>
        </div>

        <div class="lc-header-right">
          <!-- Search -->
          <div class="lc-search-wrap">
            <input
              v-model="searchQuery"
              class="lc-search"
              placeholder="Nome, QR, email…"
              @keyup.enter="onPesquisar"
            />
            <button class="lc-search-go" @click="onPesquisar">
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
              >
                <circle cx="11" cy="11" r="8" />
                <path d="m21 21-4.35-4.35" />
              </svg>
            </button>
            <button
              v-if="searchQuery"
              class="lc-search-x"
              @click="
                searchQuery = '';
                onPesquisar();
              "
            >
              ✕
            </button>
          </div>

          <!-- Filtros btn -->
          <button
            class="lc-filter-btn"
            :class="{ active: filtrosAtivos }"
            @click="verFiltros = !verFiltros"
          >
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
            >
              <line x1="4" y1="6" x2="20" y2="6" />
              <line x1="8" y1="12" x2="16" y2="12" />
              <line x1="11" y1="18" x2="13" y2="18" />
            </svg>
            Filtros
            <span v-if="filtrosAtivos" class="lc-filter-dot"></span>
          </button>

          <!-- Exportar -->
          <button class="lc-action-btn" @click="onExportar">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
            >
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <polyline points="7 10 12 15 17 10" />
              <line x1="12" y1="15" x2="12" y2="3" />
            </svg>
            Exportar
          </button>
        </div>
      </div>

      <!-- SELECTION BAR (aparece quando há seleção) -->
      <transition name="lc-bar">
        <div v-if="selectedRows.length > 0" class="lc-sel-bar">
          <div class="lc-sel-info">
            <span class="lc-sel-count">{{ selectedRows.length }}</span>
            cliente{{ selectedRows.length !== 1 ? "s" : "" }} selecionado{{
              selectedRows.length !== 1 ? "s" : ""
            }}
          </div>
          <div class="lc-sel-actions">
            <div v-if="selectedRows.length > 1" class="lc-bulk-wrap">
              <input
                v-model="descontosAtualizar"
                type="number"
                min="0"
                max="100"
                class="lc-bulk-input"
                placeholder="0"
              />
              <span class="lc-bulk-pct">%</span>
              <button
                class="lc-sel-btn lc-sel-btn-neutral"
                @click="onGuardarTodosDescontos"
              >
                Atualizar descontos
              </button>
            </div>
            <button
              class="lc-sel-btn lc-sel-btn-primary"
              @click="onEnviarMensagem"
            >
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
              >
                <line x1="22" y1="2" x2="11" y2="13" />
                <polygon points="22 2 15 22 11 13 2 9 22 2" />
              </svg>
              Enviar mensagem
            </button>
            <button
              class="lc-sel-btn lc-sel-btn-ghost"
              @click="selectedRows = []"
            >
              Cancelar
            </button>
          </div>
        </div>
      </transition>

      <!-- TABELA -->
      <div class="lc-table-wrap">
        <div class="lc-controls">
          <div class="lc-controls-left">
            <select
              v-model="perPageLocal"
              class="lc-perpage"
              @change="onPerPageChanged"
            >
              <option
                v-for="n in pagination.perPageOptions"
                :key="n"
                :value="n"
              >
                {{ n }} por página
              </option>
            </select>
            <span class="lc-info">
              {{ from + 1 }}–{{ to }} de
              {{ totalServer.toLocaleString("pt-PT") }}
              <span v-if="selectedRows.length" class="lc-info-sel">
                · {{ selectedRows.length }} selecionados</span
              >
            </span>
          </div>
          <div class="lc-controls-right">
            <button class="lc-save-seg-btn" @click.stop="modalSegmento = true">
              <svg
                width="12"
                height="12"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
              >
                <path
                  d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"
                />
                <polyline points="17 21 17 13 7 13 7 21" />
                <polyline points="7 3 7 8 15 8" />
              </svg>
              Guardar segmento
            </button>
            <div class="lc-pag">
              <button
                class="lc-pag-btn"
                :disabled="pagination.currentPage <= 1"
                @click="onPaginationChanged(pagination.currentPage - 1)"
              >
                ‹
              </button>
              <button
                v-for="p in pageNums"
                :key="p"
                class="lc-pag-btn"
                :class="{ cur: p === pagination.currentPage }"
                @click="onPaginationChanged(p)"
              >
                {{ p }}
              </button>
              <button
                class="lc-pag-btn"
                :disabled="pagination.currentPage >= totalPages"
                @click="onPaginationChanged(pagination.currentPage + 1)"
              >
                ›
              </button>
            </div>
          </div>
        </div>

        <div class="lc-scroll">
          <table class="lc-table">
            <thead>
              <tr>
                <th class="lc-th lc-th-check">
                  <span
                    class="lc-cb"
                    :class="{ on: allSelected, partial: someSelected }"
                    @click="toggleAll"
                  >
                    <svg
                      v-if="allSelected"
                      width="8"
                      height="8"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="white"
                      stroke-width="4"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                    <span v-else-if="someSelected" class="lc-cb-dash"></span>
                  </span>
                </th>
                <th class="lc-th lc-th-name">Cliente</th>
                <th class="lc-th lc-th-num">Faixa Etária</th>
                <th
                  class="lc-th lc-th-num"
                  @click="
                    onSortChange({
                      prop: 'visitas_total',
                      order:
                        sortProp === 'visitas_total' &&
                        sortOrder === 'ascending'
                          ? 'descending'
                          : 'ascending',
                    })
                  "
                >
                  <span class="lc-th-inner"
                    >Visitas
                    <svg
                      class="lc-sort"
                      width="10"
                      height="10"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2.5"
                    >
                      <path d="m7 15 5 5 5-5" />
                      <path d="m7 9 5-5 5 5" /></svg
                  ></span>
                </th>
                <th
                  class="lc-th lc-th-num"
                  @click="
                    onSortChange({
                      prop: 'gasto_total',
                      order:
                        sortProp === 'gasto_total' && sortOrder === 'ascending'
                          ? 'descending'
                          : 'ascending',
                    })
                  "
                >
                  <span class="lc-th-inner"
                    >Total Gasto
                    <svg
                      class="lc-sort"
                      width="10"
                      height="10"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2.5"
                    >
                      <path d="m7 15 5 5 5-5" />
                      <path d="m7 9 5-5 5 5" /></svg
                  ></span>
                </th>
                <th class="lc-th lc-th-num">Total Parcial</th>
                <th class="lc-th lc-th-num">Visitas Parciais</th>
                <th class="lc-th lc-th-num">Ticket Médio</th>
                <th class="lc-th lc-th-date">Data Criação</th>
                <th class="lc-th lc-th-date">Última Visita</th>
                <th class="lc-th lc-th-date">Penúltima Visita</th>
                <th class="lc-th lc-th-date">Último Envio</th>
                <th class="lc-th lc-th-num">Nº Envios</th>
                <th class="lc-th lc-th-actions"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="row in queriedData"
                :key="row.id"
                class="lc-row"
                :class="{ selected: isSelected(row) }"
                @click="toggleRow(row)"
              >
                <td class="lc-td lc-td-check" @click.stop="toggleRow(row)">
                  <span class="lc-cb" :class="{ on: isSelected(row) }">
                    <svg
                      v-if="isSelected(row)"
                      width="8"
                      height="8"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="white"
                      stroke-width="4"
                    >
                      <path d="M20 6 9 17l-5-5" />
                    </svg>
                  </span>
                </td>
                <td class="lc-td lc-td-name" @click.stop>
                  <div class="lc-client">
                    <div
                      class="lc-avatar"
                      :style="'background:' + avatarBg(row.nome)"
                    >
                      {{ initials(row.nome) }}
                    </div>
                    <div>
                      <span class="lc-client-name" @click="onVerPerfil(row)">{{
                        row.nome
                      }}</span>
                      <span class="lc-client-qr">{{ row.qr_code }}</span>
                    </div>
                  </div>
                </td>
                <td class="lc-td lc-td-num">{{ row.faixa_etaria || "—" }}</td>
                <td class="lc-td lc-td-num">{{ row.visitas_total || 0 }}</td>
                <td class="lc-td lc-td-num lc-val-strong">
                  {{ formatarEuro(row.gasto_total) }}
                </td>
                <td class="lc-td lc-td-num">
                  {{
                    row.total_parcial != null
                      ? formatarEuro(
                          Math.min(row.total_parcial, row.gasto_total || 0),
                        )
                      : "—"
                  }}
                </td>
                <td class="lc-td lc-td-num">
                  {{
                    row.visitas_parciais != null ? row.visitas_parciais : "—"
                  }}
                </td>
                <td class="lc-td lc-td-num">
                  {{ formatarEuro(row.ticket_medio) }}
                </td>
                <td class="lc-td lc-td-date">
                  {{ formatarData(row.dt_created) }}
                </td>
                <td class="lc-td lc-td-date">
                  {{ formatarData(row.ultima_visita) }}
                </td>
                <td class="lc-td lc-td-date">
                  {{ formatarData(row.penultima_visita) }}
                </td>
                <td class="lc-td lc-td-date">
                  {{ formatarData(row.ultima_envio) }}
                </td>
                <td class="lc-td lc-td-num">{{ row.total_envios || 0 }}</td>
                <td class="lc-td lc-td-actions" @click.stop>
                  <button class="lc-profile-btn" @click="onVerPerfil(row)">
                    Ver perfil
                  </button>
                </td>
              </tr>

              <!-- Empty -->
              <tr v-if="queriedData.length === 0">
                <td colspan="14" class="lc-empty-row">
                  <svg
                    width="28"
                    height="28"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="1.5"
                  >
                    <circle cx="11" cy="11" r="8" />
                    <path d="m21 21-4.35-4.35" />
                  </svg>
                  <p>Nenhum cliente encontrado</p>
                  <button
                    v-if="filtrosAtivos"
                    class="lc-clear-btn"
                    @click="onLimparFiltros"
                  >
                    Limpar filtros
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- PERFIL -->
    <ClientePerfil
      v-else-if="verPerfil && !verFiltros"
      :dados-cliente-selecionado="dadosClienteSelecionado"
      :restaurantes="restaurantes"
      @voltar="verPerfil = false"
    />

    <!-- DRAWER FILTROS -->
    <FiltrosDrawer
      :value="verFiltros"
      :filtrosDefault="filtros"
      :categoriasUnicas="categoriasUnicas"
      :restaurantes="restaurantes"
      :resultadosFiltrados="pagination.total"
      :total="pagination.total"
      :filtros_utilizador="filtros_utilizador"
      :mensagensPeriodo="mensagensPeriodo"
      :sugerirProdutos="sugerirProdutos"
      @aplicar="onReceberFiltros"
      @limpar="onLimparFiltros"
      @fechar="verFiltros = false"
    />

    <!-- MODAL GUARDAR SEGMENTO -->
    <transition name="lc-fade">
      <div
        v-if="modalSegmento"
        class="lc-overlay"
        @click.self="modalSegmento = false"
      >
        <div class="lc-modal">
          <div class="lc-modal-head">
            <div class="lc-modal-title">Guardar segmento</div>
            <button class="lc-modal-close" @click="modalSegmento = false">
              <svg
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2.5"
              >
                <path d="M18 6 6 18M6 6l12 12" />
              </svg>
            </button>
          </div>
          <div class="lc-modal-body">
            <label class="lc-label"
              >Nome <span class="lc-label-hint">máx. 30 caracteres</span></label
            >
            <input
              v-model="nomeSegmentacao"
              type="text"
              class="lc-input"
              maxlength="30"
              placeholder="Ex: Clientes VIP Lisboa"
            />
            <label class="lc-label"
              >Descrição
              <span class="lc-label-hint">máx. 40 caracteres</span></label
            >
            <textarea
              v-model="descricaoSegmentacao"
              class="lc-textarea"
              maxlength="40"
              rows="2"
              placeholder="Breve descrição do segmento"
            ></textarea>
          </div>
          <div class="lc-modal-foot">
            <button class="lc-btn lc-btn-ghost" @click="modalSegmento = false">
              Cancelar
            </button>
            <button class="lc-btn lc-btn-primary" @click="onGuardarFiltro">
              <svg
                width="13"
                height="13"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="3"
              >
                <path d="M20 6 9 17l-5-5" />
              </svg>
              Guardar
            </button>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  import { Select, Option } from "element-ui";
  import { BasePagination } from "@/components";
  import LoadingOverlay from "@/components/Loading/LoadingOverlay";
  import ClientePerfil from "./ClientePerfil.vue";
  import FiltrosDrawer from "./FiltrosDrawer.vue";
  import { useClientes } from "@/composables/useClientes";
  import { useFormatters } from "@/composables/useFormatters";
  import { usePaginacao } from "@/composables/usePaginacao";

  const AVATAR_COLORS = [
    "#ff825d",
    "#5e72e4",
    "#2dce89",
    "#f59e0b",
    "#11cdef",
    "#f5365c",
    "#8b5cf6",
    "#0ea5e9",
  ];

  const FILTROS_DEFAULT = {
    segmentacao: null,
    restaurante: [],
    genero: [],
    idade: [],
    estado: [],
    data_ultima_visita: "0",
    data_sem_visitar: "0",
    data_inscricao: "0",
    data_inscricao_de: null,
    data_inscricao_ate: null,
    total_visitas_de: null,
    total_visitas_ate: null,
    total_gasto_min: null,
    total_gasto_max: null,
    ticket_medio_min: null,
    ticket_medio_max: null,
    produtos: [
      { id: Date.now(), nome: "", vezes: null, operador: "E", match: "is" },
    ],
    total_mensagens_min: null,
    total_mensagens_max: null,
    periodo_mensagens: [],
    envios: [],
    consumoRestaurantes: [{ operador: "E", vezes: null, restaurante: null }],
    contas_individuais: { tipo: null, min: null, max: null },
  };

  export default {
    components: {
      ClientePerfil,
      BasePagination,
      FiltrosDrawer,
      LoadingOverlay,
      [Select.name]: Select,
      [Option.name]: Option,
    },

    data() {
      const { formatarEuro, formatarData } = useFormatters();
      const clientes = useClientes();
      const paginacao = usePaginacao();
      return {
        clientes,
        paginacao,
        formatarEuro,
        formatarData,
        searchQuery: "",
        verPerfil: false,
        verFiltros: false,
        modalSegmento: false,
        dadosClienteSelecionado: null,
        selectedRows: [],
        descontosAtualizar: 0,
        nomeSegmentacao: "",
        descricaoSegmentacao: "",
        filtros: JSON.parse(JSON.stringify(FILTROS_DEFAULT)),
        filtroOverride: false,
        filtroIdURL: null,
        segmentoURL: null,
        restaurantesURL: null,
        clienteForcado: null,
        sortProp: null,
        sortOrder: null,
        categoriasUnicas: [],
        mensagensPeriodo: [
          "Hoje",
          "Esta semana",
          "Este mês",
          "Últimos 3 meses",
          "Mais de 6 meses",
        ],
        perPageLocal: 50,
      };
    },

    computed: {
      // Deswrap dos refs do composable para Vue 2 Options API
      loading() {
        const v = this.clientes.loading;
        return v && v.value !== undefined ? v.value : v;
      },
      tableData() {
        const v = this.clientes.tableData;
        return v && v.value !== undefined ? v.value : v || [];
      },
      restaurantes() {
        const v = this.clientes.restaurantes;
        return v && v.value !== undefined ? v.value : v || [];
      },
      filtros_utilizador() {
        const v = this.clientes.filtros_utilizador;
        return v && v.value !== undefined ? v.value : v || [];
      },
      todosProdutos() {
        const v = this.clientes.todosProdutos;
        return v && v.value !== undefined ? v.value : v || [];
      },
      pagination() {
        return this.clientes.pagination;
      },

      // Dados já paginados pelo servidor — só ordenar localmente
      queriedData() {
        return this.paginacao.ordenarLocalmente(
          this.tableData,
          this.sortProp,
          this.sortOrder,
        );
      },

      // Totais e paginação server-side
      totalServer() {
        return this.pagination.total || 0;
      },
      perPage() {
        return this.pagination.perPage || 50;
      },
      totalPages() {
        return Math.ceil(this.totalServer / this.perPage) || 1;
      },
      from() {
        return (this.pagination.currentPage - 1) * this.perPage;
      },
      to() {
        return Math.min(this.from + this.perPage, this.totalServer);
      },
      pageNums() {
        const p = this.pagination.currentPage,
          t = this.totalPages,
          r = [];
        for (let i = Math.max(1, p - 2); i <= Math.min(t, p + 2); i++)
          r.push(i);
        return r;
      },

      allSelected() {
        return (
          this.queriedData.length > 0 &&
          this.queriedData.every((r) => this.isSelected(r))
        );
      },
      someSelected() {
        return (
          !this.allSelected && this.queriedData.some((r) => this.isSelected(r))
        );
      },

      filtrosAtivos() {
        const f = this.filtros;
        return !!(
          f.segmentacao ||
          f.restaurante.length ||
          f.genero.length ||
          f.idade.length ||
          f.estado.length ||
          (f.data_inscricao !== "0" && f.data_inscricao) ||
          (f.data_ultima_visita !== "0" && f.data_ultima_visita) ||
          (f.data_sem_visitar !== "0" && f.data_sem_visitar) ||
          f.total_visitas_de ||
          f.total_visitas_ate ||
          f.total_gasto_min ||
          f.total_gasto_max ||
          f.ticket_medio_min ||
          f.ticket_medio_max ||
          f.produtos.some((p) => p.nome || p.vezes) ||
          f.total_mensagens_min ||
          f.total_mensagens_max ||
          f.envios.length ||
          f.periodo_mensagens.length ||
          (f.consumoRestaurantes &&
            f.consumoRestaurantes.some((c) => c.restaurante && c.vezes >= 0)) ||
          (f.contas_individuais &&
            (f.contas_individuais.tipo ||
              f.contas_individuais.min ||
              f.contas_individuais.max))
        );
      },
    },

    methods: {
      initials(n) {
        if (!n) return "?";
        return n
          .trim()
          .split(/\s+/)
          .slice(0, 2)
          .map((w) => w[0])
          .join("")
          .toUpperCase();
      },
      avatarBg(n) {
        if (!n) return AVATAR_COLORS[0];
        let h = 0;
        for (let i = 0; i < n.length; i++)
          h = (h * 31 + n.charCodeAt(i)) % AVATAR_COLORS.length;
        return AVATAR_COLORS[Math.abs(h) % AVATAR_COLORS.length];
      },
      isSelected(row) {
        return this.selectedRows.some((r) => r.id === row.id);
      },
      toggleRow(row) {
        if (this.isSelected(row))
          this.selectedRows = this.selectedRows.filter((r) => r.id !== row.id);
        else this.selectedRows.push(row);
      },
      toggleAll() {
        if (this.allSelected)
          this.selectedRows = this.selectedRows.filter(
            (r) => !this.queriedData.some((q) => q.id === r.id),
          );
        else
          this.queriedData.forEach((r) => {
            if (!this.isSelected(r)) this.selectedRows.push(r);
          });
      },

      onPesquisar() {
        this.pagination.currentPage = 1;
        this._recarregar();
      },
      onPerPageChanged() {
        this.pagination.perPage = this.perPageLocal;
        this.pagination.currentPage = 1;
        this._recarregar();
      },
      onPaginationChanged(p) {
        this.pagination.currentPage = p;
        this._recarregar();
      },
      onSortChange({ prop, order }) {
        this.sortProp = prop;
        this.sortOrder = order;
      },
      async _recarregar() {
        if (this.filtrosAtivos || this.filtroOverride)
          await this.clientes.aplicarFiltros(this.filtros);
        else await this._getCartoes();
      },
      async _getCartoes() {
        await this.clientes.getCartoes({
          filtroId: this.filtroIdURL,
          clienteForcado: this.clienteForcado,
          searchQuery: this.searchQuery || null,
          segmento: this.segmentoURL,
          restaurantesParam: this.restaurantesURL,
        });
      },
      onReceberFiltros(f) {
        this.filtros = f;
        this.filtroOverride = true;
        this.pagination.currentPage = 1;
        this.clientes.aplicarFiltros(this.filtros);
      },
      onLimparFiltros() {
        this.filtros = JSON.parse(JSON.stringify(FILTROS_DEFAULT));
        this.filtroOverride = false;
        this._getCartoes();
      },
      async onVerPerfil(row) {
        try {
          this.dadosClienteSelecionado = await this.clientes.getPerfilCliente(
            row.qr_code,
          );
          this.verFiltros = false;
          this.verPerfil = true;
        } catch {
          this.$notify({
            type: "danger",
            message: "<b>Erro ao carregar perfil.</b>",
          });
        }
      },
      async onGuardarTodosDescontos() {
        if (!this.selectedRows.length)
          return this.$notify({
            type: "warning",
            message: "<b>Nenhum cliente selecionado.</b>",
          });
        const d = Number(this.descontosAtualizar);
        if (!Number.isFinite(d) || d < 0 || d > 100)
          return this.$notify({
            type: "warning",
            message: "<b>Desconto inválido.</b>",
          });
        const qrCodes = this.selectedRows
          .map((r) => String(r.qr_code).trim())
          .filter(Boolean);
        try {
          const res = await this.clientes.iniciarBulkDesconto(qrCodes, d);
          this.$notify({
            type: "success",
            message: `<b>Processo iniciado (ID ${res.bulk_id}).</b>`,
            timeout: 4000,
          });
        } catch {
          this.$notify({
            type: "danger",
            message: "<b>Erro ao iniciar o processo.</b>",
          });
        }
      },
      onExportar() {
        if (!this.clientes.exportarCSV(this.tableData))
          this.$notify({
            type: "warning",
            message: "Não há dados para exportar.",
          });
      },
      onEnviarMensagem() {
        if (!this.selectedRows.length)
          return this.$notify({
            type: "warning",
            message: "<b>Selecione pelo menos um cliente.</b>",
          });
        localStorage.setItem(
          "Abitue_enviarPara",
          JSON.stringify(this.selectedRows.map((r) => r.qr_code)),
        );
        this.$router.push({
          path: "/campanhas/criar",
          query: { enviarIndividual: true },
        });
      },
      async onGuardarFiltro() {
        const nome = this.nomeSegmentacao,
          desc = this.descricaoSegmentacao;
        if (!this.filtrosAtivos)
          return this.$notify({
            type: "warning",
            message: "Preencha pelo menos um filtro antes de guardar.",
          });
        if (!nome.trim() || nome.trim().length > 30)
          return this.$notify({
            type: "warning",
            message: "Nome inválido (máx. 30 caracteres).",
          });
        if (!desc.trim() || desc.trim().length > 40)
          return this.$notify({
            type: "warning",
            message: "Descrição inválida (máx. 40 caracteres).",
          });
        try {
          await this.clientes.guardarFiltro(nome, desc, this.filtros);
          this.$notify({
            type: "success",
            message: "Segmento guardado com sucesso.",
          });
          this.modalSegmento = false;
          this.nomeSegmentacao = "";
          this.descricaoSegmentacao = "";
        } catch {
          this.$notify({
            type: "danger",
            message: "Erro ao guardar segmento.",
          });
        }
      },
      sugerirProdutos(query, cb) {
        if (!query) return cb([]);
        cb(
          this.todosProdutos
            .filter((p) => p.toLowerCase().includes(query.toLowerCase()))
            .map((p) => ({ value: p })),
        );
      },
    },

    async mounted() {
      this.filtroIdURL = this.$route.query.grupo || null;
      this.segmentoURL = this.$route.query.segmento || null;
      const rests = this.$route.query.restaurantes;
      if (rests) this.restaurantesURL = rests.split(",");
      this.clienteForcado = this.$route.query.cliente || null;
      await this.clientes.carregarFiltros();
      if (this.filtroIdURL) {
        const fg = this.clientes.filtros_utilizador.find(
          (x) => x.id == this.filtroIdURL,
        );
        if (fg) {
          try {
            const fj = JSON.parse(fg.filtro_json);
            this.filtros = {
              ...JSON.parse(JSON.stringify(FILTROS_DEFAULT)),
              ...fj,
              segmentacao: String(fg.id),
            };
          } catch {}
        }
      }
      await this._getCartoes();
      await this.clientes.carregarRestaurantes();
      if (this.clienteForcado) {
        const c = this.clientes.tableData.find(
          (x) => String(x.qr_code) === String(this.clienteForcado),
        );
        if (c) {
          this.onVerPerfil(c);
          this.clienteForcado = null;
        }
      }
      this.debouncedSearch = this.paginacao.debounce(() => {
        this.pagination.currentPage = 1;
        this._getCartoes();
      }, 400);
    },
  };
</script>

<style scoped>
  .lc-root {
    padding: 28px 28px 48px;
    font-family: "DM Sans", "Outfit", system-ui, sans-serif;
    min-height: 100vh;
    background: #f8f6f3;
  }

  /* HEADER */
  .lc-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 16px;
    flex-wrap: wrap;
  }
  .lc-header-left {
    display: flex;
    align-items: center;
    gap: 14px;
  }
  .lc-header-right {
    display: flex;
    align-items: center;
    gap: 10px;
    flex-wrap: wrap;
  }
  .lc-header-icon {
    width: 44px;
    height: 44px;
    flex-shrink: 0;
    background: #ff825d;
    border-radius: 13px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    box-shadow: 0 4px 14px rgba(255, 130, 93, 0.3);
  }
  .lc-title {
    font-size: 20px;
    font-weight: 800;
    color: #1a1210;
    margin: 0;
    letter-spacing: -0.4px;
  }
  .lc-sub {
    font-size: 13px;
    color: #b0a8a0;
    margin: 3px 0 0;
  }

  .lc-search-wrap {
    display: flex;
    align-items: center;
    background: #fff;
    border: 1.5px solid #f0ece8;
    border-radius: 11px;
    overflow: hidden;
    transition: border-color 0.15s;
  }
  .lc-search-wrap:focus-within {
    border-color: #ff825d;
  }
  .lc-search {
    background: none;
    border: none;
    outline: none;
    font-size: 13.5px;
    color: #1a1210;
    width: 180px;
    font-family: inherit;
    padding: 9px 8px 9px 13px;
  }
  .lc-search::placeholder {
    color: #c0b8b0;
  }
  .lc-search-go {
    background: transparent;
    border: none;
    cursor: pointer;
    color: #ff825d;
    padding: 0 13px;
    height: 100%;
    min-height: 38px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.15s;
    flex-shrink: 0;
  }
  .lc-search-x {
    background: none;
    border: none;
    cursor: pointer;
    color: #c0b8b0;
    font-size: 12px;
    padding: 0 8px;
    flex-shrink: 0;
  }

  .lc-filter-btn {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    position: relative;
    padding: 10px 16px;
    background: #fff;
    border: 1.5px solid #f0ece8;
    border-radius: 11px;
    font-size: 13.5px;
    font-weight: 500;
    color: #5a534f;
    cursor: pointer;
    transition: all 0.15s;
    font-family: inherit;
  }
  .lc-filter-btn:hover {
    border-color: #e0d8d0;
    color: #1a1210;
  }
  .lc-filter-btn.active {
    border-color: #ff825d;
    color: #ff825d;
    background: #fff8f5;
  }
  .lc-filter-dot {
    width: 7px;
    height: 7px;
    background: #ff825d;
    border-radius: 50%;
    position: absolute;
    top: 7px;
    right: 7px;
  }

  .lc-action-btn {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 10px 16px;
    background: #fff;
    border: 1.5px solid #f0ece8;
    border-radius: 11px;
    font-size: 13.5px;
    font-weight: 500;
    color: #5a534f;
    cursor: pointer;
    transition: all 0.15s;
    font-family: inherit;
    white-space: nowrap;
  }
  .lc-action-btn:hover {
    border-color: #e0d8d0;
    color: #1a1210;
  }

  /* SELECTION BAR */
  .lc-sel-bar {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 12px 20px;
    margin-bottom: 14px;
    background: #1a1210;
    border-radius: 14px;
    flex-wrap: wrap;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  }
  .lc-sel-info {
    font-size: 13.5px;
    color: rgba(255, 255, 255, 0.6);
    white-space: nowrap;
  }
  .lc-sel-count {
    font-weight: 800;
    color: #ff825d;
    font-size: 16px;
    margin-right: 4px;
  }
  .lc-sel-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
  }
  .lc-bulk-wrap {
    display: flex;
    align-items: center;
    gap: 6px;
  }
  .lc-bulk-input {
    width: 54px;
    height: 34px;
    text-align: center;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 8px;
    color: #fff;
    font-size: 15px;
    font-weight: 700;
    outline: none;
    font-family: inherit;
  }
  .lc-bulk-input:focus {
    border-color: #ff825d;
  }
  .lc-bulk-pct {
    font-size: 13px;
    color: rgba(255, 255, 255, 0.4);
  }
  .lc-sel-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 7px 13px;
    border: none;
    border-radius: 9px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s;
    font-family: inherit;
  }
  .lc-sel-btn-primary {
    background: #ff825d;
    color: #fff;
    box-shadow: 0 2px 8px rgba(255, 130, 93, 0.35);
  }
  .lc-sel-btn-primary:hover {
    background: #e86b45;
  }
  .lc-sel-btn-neutral {
    background: rgba(255, 255, 255, 0.12);
    color: rgba(255, 255, 255, 0.8);
  }
  .lc-sel-btn-neutral:hover {
    background: rgba(255, 255, 255, 0.2);
  }
  .lc-sel-btn-ghost {
    background: none;
    color: rgba(255, 255, 255, 0.4);
  }
  .lc-sel-btn-ghost:hover {
    color: rgba(255, 255, 255, 0.7);
  }

  /* TABLE WRAP */
  .lc-table-wrap {
    background: #fff;
    border: 1.5px solid #f0ece8;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04), 0 4px 14px rgba(0, 0, 0, 0.05);
  }
  .lc-controls {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 12px 18px;
    border-bottom: 1px solid #f5f2ef;
    flex-wrap: wrap;
    gap: 10px;
  }
  .lc-controls-left,
  .lc-controls-right {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .lc-perpage {
    padding: 6px 10px;
    border: 1.5px solid #e8e4e0;
    border-radius: 8px;
    font-size: 13px;
    background: #faf8f6;
    color: #5a534f;
    outline: none;
    cursor: pointer;
    font-family: inherit;
  }
  .lc-perpage:focus {
    border-color: #ff825d;
  }
  .lc-info {
    font-size: 13px;
    color: #a09890;
  }
  .lc-info-sel {
    color: #ff825d;
    font-weight: 600;
  }
  .lc-save-seg-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 7px 13px;
    background: #f7f4f1;
    border: 1.5px solid #e8e4e0;
    border-radius: 9px;
    font-size: 13px;
    font-weight: 600;
    color: #5a534f;
    cursor: pointer;
    transition: all 0.15s;
    font-family: inherit;
    white-space: nowrap;
  }
  .lc-save-seg-btn:hover {
    border-color: #ff825d;
    color: #ff825d;
    background: #fff8f5;
  }

  .lc-pag {
    display: flex;
    gap: 3px;
  }
  .lc-pag-btn {
    min-width: 32px;
    height: 32px;
    padding: 0 6px;
    border: 1.5px solid #e8e4e0;
    border-radius: 8px;
    background: #fff;
    font-size: 13px;
    color: #6b6460;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.15s;
    font-family: inherit;
  }
  .lc-pag-btn:hover:not(:disabled) {
    border-color: #ff825d;
    color: #ff825d;
  }
  .lc-pag-btn:disabled {
    opacity: 0.35;
    cursor: default;
  }
  .lc-pag-btn.cur {
    background: #ff825d;
    border-color: #ff825d;
    color: #fff;
    font-weight: 700;
  }

  .lc-scroll {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
  }
  .lc-table {
    width: 100%;
    border-collapse: collapse;
    font-size: 13.5px;
  }
  .lc-th {
    padding: 10px 14px;
    background: #faf8f6;
    border-bottom: 1px solid #f0ece8;
    font-size: 11px;
    font-weight: 700;
    color: #b0a8a0;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    text-align: left;
    white-space: nowrap;
  }
  .lc-th-check {
    width: 46px;
  }
  .lc-th-name {
    min-width: 200px;
  }
  .lc-th-num {
    width: 130px;
    text-align: right;
    cursor: pointer;
  }
  .lc-th-num:hover {
    color: #7a736e;
  }
  .lc-th-date {
    width: 120px;
  }
  .lc-th-actions {
    width: 100px;
  }
  .lc-th-inner {
    display: inline-flex;
    align-items: center;
    gap: 4px;
  }
  .lc-sort {
    opacity: 0.4;
  }

  .lc-row {
    border-bottom: 1px solid #f8f5f2;
    cursor: pointer;
    transition: background 0.08s;
  }
  .lc-row:hover {
    background: #fdfcfb;
  }
  .lc-row.selected {
    background: #fff8f5;
  }
  .lc-row:last-child {
    border-bottom: none;
  }

  .lc-td {
    padding: 12px 14px;
    vertical-align: middle;
  }
  .lc-td-num {
    text-align: right;
    color: #3a3430;
    font-variant-numeric: tabular-nums;
  }
  .lc-td-date {
    color: #8a857e;
    font-size: 13px;
    white-space: nowrap;
  }
  .lc-td-check {
    width: 46px;
  }

  /* Checkbox */
  .lc-cb {
    width: 17px;
    height: 17px;
    border-radius: 5px;
    border: 1.5px solid #d8d0c8;
    background: #fff;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.12s;
  }
  .lc-cb:hover {
    border-color: #ff825d;
  }
  .lc-cb.on {
    background: #ff825d;
    border-color: #ff825d;
  }
  .lc-cb.partial {
    background: #ffd8c8;
    border-color: #ff825d;
  }
  .lc-cb-dash {
    width: 8px;
    height: 2px;
    background: #ff825d;
    border-radius: 1px;
  }

  /* Client cell */
  .lc-client {
    display: flex;
    align-items: center;
    gap: 10px;
  }
  .lc-avatar {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    color: #fff;
    font-size: 11px;
    font-weight: 700;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }
  .lc-client-name {
    display: block;
    font-size: 13.5px;
    font-weight: 600;
    color: #1a1210;
    cursor: pointer;
    transition: color 0.12s;
    white-space: nowrap;
  }
  .lc-client-name:hover {
    color: #ff825d;
    text-decoration: underline;
  }
  .lc-client-qr {
    display: block;
    font-size: 11px;
    color: #b0a8a0;
    font-family: monospace;
    margin-top: 1px;
  }

  .lc-val-strong {
    font-weight: 700;
    color: #1a1210;
  }

  .lc-profile-btn {
    padding: 5px 11px;
    background: #f7f4f1;
    border: none;
    border-radius: 7px;
    font-size: 12px;
    font-weight: 600;
    color: #5a534f;
    cursor: pointer;
    transition: all 0.12s;
    font-family: inherit;
    white-space: nowrap;
  }
  .lc-profile-btn:hover {
    background: #fff0eb;
    color: #ff825d;
  }

  /* Empty row */
  .lc-empty-row {
    text-align: center;
    padding: 48px 20px;
    color: #b0a8a0;
  }
  .lc-empty-row svg {
    display: block;
    margin: 0 auto 12px;
    opacity: 0.4;
  }
  .lc-empty-row p {
    font-size: 14px;
    margin-bottom: 16px;
  }
  .lc-clear-btn {
    padding: 8px 18px;
    background: #f7f4f1;
    border: none;
    border-radius: 9px;
    font-size: 13.5px;
    color: #5a534f;
    cursor: pointer;
    font-family: inherit;
  }
  .lc-clear-btn:hover {
    background: #f0ece8;
  }

  /* MODAL */
  .lc-overlay {
    position: fixed;
    inset: 0;
    background: rgba(15, 10, 8, 0.45);
    backdrop-filter: blur(6px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1200;
    padding: 16px;
  }
  .lc-modal {
    background: #fff;
    border-radius: 18px;
    width: 100%;
    max-width: 440px;
    box-shadow: 0 24px 80px rgba(0, 0, 0, 0.2);
    overflow: hidden;
  }
  .lc-modal-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 24px 16px;
    border-bottom: 1px solid #f5f2ef;
  }
  .lc-modal-title {
    font-size: 16px;
    font-weight: 700;
    color: #1a1210;
  }
  .lc-modal-close {
    background: #f7f4f1;
    border: none;
    cursor: pointer;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #7a736e;
    transition: all 0.12s;
  }
  .lc-modal-close:hover {
    background: #f0ece8;
    color: #1a1210;
  }
  .lc-modal-body {
    padding: 20px 24px;
    display: flex;
    flex-direction: column;
    gap: 14px;
  }
  .lc-label {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 700;
    color: #8a857e;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin-bottom: 6px;
  }
  .lc-label-hint {
    font-size: 11px;
    color: #c0b8b0;
    text-transform: none;
    letter-spacing: 0;
    font-weight: 400;
  }
  .lc-input,
  .lc-textarea {
    width: 100%;
    padding: 11px 14px;
    border: 1.5px solid #e8e4e0;
    border-radius: 10px;
    font-size: 14px;
    color: #1a1210;
    outline: none;
    font-family: inherit;
    transition: border-color 0.15s;
  }
  .lc-textarea {
    resize: none;
  }
  .lc-input:focus,
  .lc-textarea:focus {
    border-color: #ff825d;
    box-shadow: 0 0 0 3px rgba(255, 130, 93, 0.12);
  }
  .lc-modal-foot {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    padding: 16px 24px;
    border-top: 1px solid #f5f2ef;
  }
  .lc-btn {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 10px 18px;
    border: none;
    border-radius: 10px;
    font-size: 13.5px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s;
    font-family: inherit;
  }
  .lc-btn-ghost {
    background: #f7f4f1;
    color: #5a534f;
  }
  .lc-btn-ghost:hover {
    background: #f0ece8;
  }
  .lc-btn-primary {
    background: #ff825d;
    color: #fff;
    box-shadow: 0 2px 8px rgba(255, 130, 93, 0.3);
  }
  .lc-btn-primary:hover {
    background: #e86b45;
  }

  .lc-bar-enter-active {
    transition: all 0.25s cubic-bezier(0.22, 0.68, 0, 1.2);
  }
  .lc-bar-leave-active {
    transition: all 0.18s ease;
  }
  .lc-bar-enter,
  .lc-bar-leave-to {
    opacity: 0;
    transform: translateY(-8px);
  }
  .lc-fade-enter-active {
    transition: opacity 0.2s;
  }
  .lc-fade-leave-active {
    transition: opacity 0.15s;
  }
  .lc-fade-enter,
  .lc-fade-leave-to {
    opacity: 0;
  }

  @media (max-width: 768px) {
    .lc-root {
      padding: 16px 12px 40px;
    }
    .lc-search {
      width: 130px;
    }
    .lc-client-qr {
      display: none;
    }
    .lc-th-date,
    .lc-td-date {
      display: none;
    }
  }
</style>

<style>
  button#demografico {
    background: rgba(89, 255, 160, 0.3);
    border: none;
    color: #6e6e6e;
  }
  button#comportamento {
    background: rgba(141, 117, 252, 0.3);
    border: none;
    color: #6e6e6e;
  }
  button#consumo {
    background: rgba(255, 93, 44, 0.3);
    border: none;
    color: #6e6e6e;
  }
  button#comunicacao {
    background: rgba(52, 0, 104, 0.2);
    border: none;
    color: #6e6e6e;
  }
</style>
